import { Grid, Stack, Typography } from "@mui/material";
import { useLangContext } from "../../../../context/langContext";
import { VoiceBroadcastDetailsSchema } from "../../../../services/Schemas/Broadcast";
import AudioPlayer2 from "../../../common/audio-player/AudioPlayer";
import {
  changeToToman,
  formatCurrency,
} from "../../../../utils/currency-formater";

import BroadCastStatusReport from "./BroadcastStatusReport";
import BroadcastReactionReport from "./BroadcastReactionReport";
import BroadcastNumReactionReport from "./BroadcastNumReactionReport";
import BroadCastingMedSectionSkeletonComponent from "./BroadcastingMedSecSkeleton";
import BroadcastFailStatusReport from "./BroadcastFailStatusReport";
import { VoiceBroadCastReportSchema } from "../../../../services/Endpoints/broadcast";

interface IBroadCastingMedSecProps {
  broadcastingInfo?: VoiceBroadcastDetailsSchema;
  initialReports?: VoiceBroadCastReportSchema[] | null;
  loading: boolean;
}

const compInfo = {
  fa: {
    contact: "مخاطب",
    status: {
      inProcess: "درحال تماس",
      fail: "تماس های ناموفق",
      inLine: "صف ارسال",
      success: "تماس های پاسخ داده شده",
    },
    infoSec: {
      numberOfCalls: "دفعات تکرار تماس‌ها",
      lengthOfFile: "مدت زمان فایل صوتی",
      contacts: "تعداد مخاطبین",
      totalPrice: "مبلغ نهایی",
      pricePerCall: "هزینه‌ی هر تماس",
      pickup_loop_counter: " تعداد برداشت در هر دفعه",
      pickup_count: " تعداد کل دفعات برداشت",
      send_speed: "سرعت ارسال تماس‌ها",
      speed_message: { fast: "سریع", normal: "عادی" },
      totalTime: "مدت زمان کل تماس‌های کمپین",
    },

    units: {
      second: "ثانیه",
      contacts: "مخاطب",
      count: "بار",
      price: "تومان",
    },
  },
  en: {
    contact: "Contact",
    status: {
      inProcess: "in process",
      fail: "failed",
      inLine: "queued",
      success: "success",
    },
    infoSec: {
      numberOfCalls: "Number of call repetitions",
      lengthOfFile: "Audio file duration",
      contacts: "Number of contacts",
      totalPrice: "Final amount",
      pricePerCall: "Cost per call",
      pickup_loop_counter: "Number of withdrawals per time",
      pickup_count: "Total number of withdrawals",
      send_speed: "Call sending speed",
      speed_message: { fast: "fast", normal: "normal" },
      totalTime: "Total campaign call duration",
    },
    units: {
      second: "second",
      contacts: "contact",
      count: "times",
      price: "Toman",
    },
  },
};
export default function BroadCastingMedSectionComponent({
  broadcastingInfo,
  initialReports = null,
  loading,
}: Readonly<IBroadCastingMedSecProps>) {
  const { lang } = useLangContext();
  const info = compInfo[lang];
  console.log(broadcastingInfo);

  return broadcastingInfo ? (
    <Stack>
      <Grid container spacing={2}>
        <Grid item xs={12} lg={6}>
          <BroadCastStatusReport
            id={broadcastingInfo.id}
            type={broadcastingInfo.type}
            initialReports={initialReports}
            loading={loading}
          />
        </Grid>

        <Grid item xs={12} lg={6}>
          <BroadcastFailStatusReport
            id={broadcastingInfo.id}
            type={broadcastingInfo.type}
            initialReports={initialReports}
            loading={loading}
          />
        </Grid>

        <Grid item xs={12} lg={6}>
          <BroadcastReactionReport
            id={broadcastingInfo.id}
            type={broadcastingInfo.type}
            initialReports={initialReports}
            loading={loading}
          />
        </Grid>

        <Grid item xs={12} lg={6}>
          <BroadcastNumReactionReport
            id={broadcastingInfo.id}
            type={broadcastingInfo.type}
            initialReports={initialReports}
            loading={loading}
          />
        </Grid>
      </Grid>

      <Stack
        mt="36px"
        gap="24px"
        direction="column"
        sx={{
          bgcolor: "white",
          borderRadius: "8px",
          py: "14px",
          px: "16px",
          borderColor: (theme) => theme.palette.others.borderColor,
          borderWidth: "1px",
          borderStyle: "solid",
          boxShadow: "none",
        }}
      >

        <Stack
          direction="column"
          justifyContent="space-between"
          alignItems="space-between"
          gap="10px"
          flexWrap="wrap"
        >
          <Stack
            direction="row"
            width="100%"
            justifyContent="space-between"
            sx={{
              borderBottomWidth: ".5px",
              borderBottomColor: "#ECEFF1",
              borderBottomStyle: "solid",
            }}
          >
            <Typography
              variant="h6MediumBold"
              color={(theme) => theme.palette.dark[40]}
            >
              {info.infoSec.numberOfCalls} :
            </Typography>
            <Typography
              variant="h6MediumBold"
              color={(theme) => theme.palette.accent.main}
            >
              {broadcastingInfo.retry_count} {info.units.count}
            </Typography>
          </Stack>

          <Stack
            direction="row"
            gap="6px"
            width="100%"
            justifyContent="space-between"
            sx={{
              borderBottomWidth: ".5px",
              borderBottomColor: "#ECEFF1",
              borderBottomStyle: "solid",
            }}
          >
            <Typography
              variant="h6MediumBold"
              color={(theme) => theme.palette.dark[40]}
            >
              {info.infoSec.lengthOfFile} :
            </Typography>
            <Typography
              variant="h6MediumBold"
              color={(theme) => theme.palette.accent.main}
            >
              {broadcastingInfo.file_duration} {info.units.second}
            </Typography>
          </Stack>

          <Stack
            direction="row"
            gap="6px"
            width="100%"
            justifyContent="space-between"
            sx={{
              borderBottomWidth: ".5px",
              borderBottomColor: "#ECEFF1",
              borderBottomStyle: "solid",
            }}
          >
            <Typography
              variant="h6MediumBold"
              color={(theme) => theme.palette.dark[40]}
            >
              {info.infoSec.contacts} :
            </Typography>
            <Typography
              variant="h6MediumBold"
              color={(theme) => theme.palette.accent.main}
            >
              {broadcastingInfo.total_numbers} {info.units.contacts}
            </Typography>
          </Stack>
          <Stack
            direction="row"
            gap="6px"
            width="100%"
            justifyContent="space-between"
            sx={{
              borderBottomWidth: ".5px",
              borderBottomColor: "#ECEFF1",
              borderBottomStyle: "solid",
            }}
          >
            <Typography
              variant="h6MediumBold"
              color={(theme) => theme.palette.dark[40]}
            >
              {info.infoSec.pickup_loop_counter} :
            </Typography>
            <Typography
              variant="h6MediumBold"
              color={(theme) => theme.palette.accent.main}
            >
              {broadcastingInfo.pickup_loop_counter} {info.units.count}
            </Typography>
          </Stack>
          <Stack
            direction="row"
            gap="6px"
            width="100%"
            justifyContent="space-between"
            sx={{
              borderBottomWidth: ".5px",
              borderBottomColor: "#ECEFF1",
              borderBottomStyle: "solid",
            }}
          >
            <Typography
              variant="h6MediumBold"
              color={(theme) => theme.palette.dark[40]}
            >
              {info.infoSec.pickup_count} :
            </Typography>
            <Typography
              variant="h6MediumBold"
              color={(theme) => theme.palette.accent.main}
            >
              {broadcastingInfo.pickup_count} {info.units.count}
            </Typography>
          </Stack>
          <Stack
            direction="row"
            gap="6px"
            width="100%"
            justifyContent="space-between"
            sx={{
              borderBottomWidth: ".5px",
              borderBottomColor: "#ECEFF1",
              borderBottomStyle: "solid",
            }}
          >
            <Typography
              variant="h6MediumBold"
              color={(theme) => theme.palette.dark[40]}
            >
              {info.infoSec.send_speed} :
            </Typography>
            <Typography
              variant="h6MediumBold"
              color={(theme) => theme.palette.accent.main}
            >
              {info.infoSec.speed_message[
                broadcastingInfo.send_speed as "fast" | "normal"
              ] || "نامشخص"}{" "}
            </Typography>
          </Stack>

          <Stack
            direction="row"
            gap="6px"
            width="100%"
            justifyContent="space-between"
            sx={{
              borderBottomWidth: ".5px",
              borderBottomColor: "#ECEFF1",
              borderBottomStyle: "solid",
            }}
          >
            <Typography
              variant="h6MediumBold"
              color={(theme) => theme.palette.dark[40]}
            >
              {info.infoSec.totalPrice} :
            </Typography>
            <Typography
              variant="h6MediumBold"
              color={(theme) => theme.palette.accent.main}
            >
              {formatCurrency(
                changeToToman(`${broadcastingInfo.estimated_cost ?? 0}`)
              )}
              {"  "}
              {info.units.price}
            </Typography>
          </Stack>

          <Stack
            direction="row"
            gap="6px"
            width="100%"
            justifyContent="space-between"
            sx={{
              borderBottomWidth: ".5px",
              borderBottomColor: (thm) => thm.palette.gray[200],
              borderBottomStyle: "solid",
            }}
          >
            <Typography
              variant="h6MediumBold"
              color={(theme) => theme.palette.dark[40]}
            >
              {info.infoSec.pricePerCall} :
            </Typography>
            <Typography
              variant="h6MediumBold"
              color={(theme) => theme.palette.accent.main}
            >
              {formatCurrency(
                changeToToman(
                  `${
                    Math.ceil(
                      broadcastingInfo.file_duration /
                        broadcastingInfo.cost_interval_value
                    ) * broadcastingInfo.cost_interval_amount
                  }`
                )
              )}{" "}
              {info.units.price}
            </Typography>
          </Stack>

          <Stack
            direction="row"
            gap="6px"
            width="100%"
            justifyContent="space-between"
            sx={{
              borderBottomWidth: ".5px",
              borderBottomColor: (thm) => thm.palette.gray[200],
              borderBottomStyle: "solid",
            }}
          >
            <Typography
              variant="h6MediumBold"
              color={(theme) => theme.palette.dark[40]}
            >
              {info.infoSec.totalTime} :
            </Typography>
            <Typography
              variant="h6MediumBold"
              color={(theme) => theme.palette.accent.main}
            >
              {broadcastingInfo.estimated_duration} {info.units.second}
            </Typography>
          </Stack>
          <Stack
            direction="row"
            justifyContent="end"
            alignItems="center"
            width="100%"
            mt="4px"
          >
            <AudioPlayer2
              src={broadcastingInfo.file.url}
              name={broadcastingInfo.file.caption ?? broadcastingInfo.file.name}
            />
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  ) : (
    <BroadCastingMedSectionSkeletonComponent />
  );
}
